/* qtrat 2026-10-23: search across spellings (Wasim picked suggestion 3). Product data is not touched.
   A customer word is searched together with the catalog's other spellings of it: hamza forms, ة/ه, ى/ي, غ/ج, with or
   without ال / و / ب, and the same word plus/minus long vowels (أوميغا -> أوميجا, جلايسنيت -> جلايسينيت, بربرين -> بيربارين).
   The query changes only when the catalog really spells a word differently (other spellings >= 1/4 of the customer's
   own spelling); otherwise it goes to Shopify exactly as typed, so typo tolerance stays as it is today.
   Used by: the live search drawer (assets/custom.js calls qtratLiveSearch.expand), every search form (/search and
   /en/search) and the drawer's "view all" link. The results page shows the customer's own words again.
   Dictionary: assets/qtrat-search-dict.js (sitewide/build_search_dict.py), loaded on the first search focus only.
   Source: Desktop/qatarat/2026-10-23-homepage/sitewide/qtrat-search.js */
(function () {
  'use strict';
  if (window.__qtratSearchOn) return;
  window.__qtratSearchOn = true;
  var CFG = window.qtratSearchCfg || {};
  var D = null, loading = null;
  var MARKS = /[\u064B-\u065F\u0670\u0640]/g, AR = /^[\u0621-\u064A]+$/;
  var VOWELS = '\u0627\u0648\u064A';  // ا و ي
  var PRE = /^(\u0648\u0627\u0644|\u0628\u0627\u0644|\u0641\u0627\u0644|\u0643\u0627\u0644|\u0644\u0644|\u0627\u0644)(.{3,})$/;  // وال بال فال كال لل ال

  function norm(w) {
    return w.replace(MARKS, '').replace(/[\u0623\u0625\u0622\u0671]/g, '\u0627').replace(/\u0629/g, '\u0647')
      .replace(/\u0649/g, '\u064A').replace(/\u0624/g, '\u0648').replace(/\u0626/g, '\u064A').replace(/\u063A/g, '\u062C');
  }
  function key(w) { var n = norm(w), m = n.match(PRE); return m ? m[2] : n; }
  function skel(k) { return k.replace(/[\u0627\u0648\u064A]/g, ''); }
  function vowelsAdded(a, b) {  // b is a with long vowels inserted
    if (b.length <= a.length) return false;
    var i = 0;
    for (var j = 0; j < b.length; j++) {
      if (i < a.length && a.charAt(i) === b.charAt(j)) i++;
      else if (VOWELS.indexOf(b.charAt(j)) === -1) return false;
    }
    return i === a.length;
  }

  function index(dict) {
    var bySkel = {};
    Object.keys(dict).forEach(function (k) { var s = skel(k); (bySkel[s] = bySkel[s] || []).push(k); });
    return { byKey: dict, bySkel: bySkel };
  }
  function load() {
    if (D) return Promise.resolve();
    if (loading) return loading;
    if (!CFG.dict) return Promise.resolve();
    loading = new Promise(function (res) {
      var s = document.createElement('script');
      s.src = CFG.dict;
      s.async = true;
      s.onload = function () { if (window.qtratSearchDict) D = index(window.qtratSearchDict); res(); };
      s.onerror = function () { loading = null; res(); };
      document.head.appendChild(s);
    });
    return loading;
  }

  function variants(w) {
    var k = key(w), out = {}, own = 0;
    function add(k2) {
      (D.byKey[k2] || []).forEach(function (e) { if (e[0] === w) own = e[1]; else out[e[0]] = e[1]; });
    }
    add(k);
    if (k.length >= 5) {
      (D.bySkel[skel(k)] || []).forEach(function (k2) {
        if (k2 !== k && (vowelsAdded(k, k2) || vowelsAdded(k2, k))) add(k2);
      });
    }
    var vs = Object.keys(out).sort(function (a, b) { return out[b] - out[a]; }).slice(0, 5);
    var sum = vs.reduce(function (t, v) { return t + out[v]; }, 0);
    return { own: own, vs: vs, sum: sum };
  }

  function expand(q) {
    if (!D || typeof q !== 'string') return q;
    var words = q.trim().split(/\s+/);
    if (!words[0] || words.length > 6 || /[()"]/.test(q) || /(^|\s)(OR|AND|NOT)(\s|$)/.test(q)) return q;
    var info = words.map(function (w) {
      var c = w.replace(MARKS, '');
      return AR.test(c) && c.length >= 3 ? variants(c) : null;
    });
    var worth = info.some(function (v) { return v && v.vs.length && v.sum >= Math.max(1, Math.ceil(v.own / 4)); });
    if (!worth) return q;
    return words.map(function (w, i) {
      var v = info[i];
      return v && v.vs.length ? '(' + [w.replace(MARKS, '')].concat(v.vs).join(' OR ') + ')' : w;
    }).join(' ');
  }
  function collapse(q) {  // our groups back to the customer's own word (the first one in each group)
    return String(q).replace(/\(([\u0621-\u064A]+(?: OR [\u0621-\u064A]+)+)\)/g, function (m, g) { return g.split(' OR ')[0]; });
  }
  window.qtratSearchExpand = expand;  // for checks from the console
  if (window.qtratLiveSearch) window.qtratLiveSearch.expand = expand;

  function isSearchPath(path) { return /\/search\/?$/.test(path || ''); }
  function searchInput(t) {
    return t && t.matches && t.matches('input[name="q"], input[type="search"]');
  }
  document.addEventListener('focusin', function (e) { if (searchInput(e.target)) load(); }, true);
  document.addEventListener('input', function (e) { if (searchInput(e.target)) load(); }, true);

  // search forms: send the expanded query, keep every other field of the form
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || e.defaultPrevented) return;
    var action = (f.getAttribute('action') || '').split('?')[0];
    if (!isSearchPath(action) || f.querySelector('[aria-selected="true"] a')) return;
    var fd = new FormData(f), q = fd.get('q');
    if (!q || typeof q !== 'string') return;
    function go() {
      var x = expand(q);
      if (x === q) return false;
      var p = new URLSearchParams();
      fd.forEach(function (v, k) { p.append(k, k === 'q' ? x : v); });
      window.location.href = action + '?' + p.toString();
      return true;
    }
    if (D) { if (go()) e.preventDefault(); return; }
    e.preventDefault();  // the dictionary is not here yet: wait for it (at most 1.5 s), then search
    var done = false;
    function finish() { if (done) return; done = true; if (!go()) HTMLFormElement.prototype.submit.call(f); }
    load().then(finish);
    setTimeout(finish, 1500);
  }, true);

  // links to the results page (the drawer's "view all")
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="search?"]') : null;
    if (!a || !D) return;
    try {
      var u = new URL(a.href, location.href), q = u.searchParams.get('q');
      if (!isSearchPath(u.pathname) || !q) return;
      var x = expand(q);
      if (x !== q) { u.searchParams.set('q', x); a.href = u.toString(); }
    } catch (err) {}
  }, true);

  // results page: show the customer's own words, not the expanded query
  if (isSearchPath(location.pathname)) {
    load();
    var q = new URLSearchParams(location.search).get('q') || '', c = collapse(q);
    if (c !== q) {
      var fix = function () {
        document.querySelectorAll('input[name="q"]').forEach(function (i) { if (i.value === q) i.value = c; });
        if (document.title.indexOf(q) !== -1) document.title = document.title.split(q).join(c);
        var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { if (n.nodeValue.indexOf(q) !== -1) n.nodeValue = n.nodeValue.split(q).join(c); }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
    }
  }
})();
